// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardSearchBox_container__DFCmv","inputArea":"DashboardSearchBox_inputArea__TULTF"};